<template>
    <div class="flex w-full gap-4 overflow-auto p-4">
        <div
            v-for="accessory in chosenAccessories"
            :key="accessory"
            class="border-dashed border-4 rounded-md p-4 w-56 text-center relative flex flex-col justify-between"
        >
            <div class="aspect-[1.777]">
                <img
                    :src="
                        $apiUrl() +
                        '/storage/assets/images/accessories_pictures/' +
                        accessory.accessories_catalog_id +
                        '/A_mini.jpg'
                    "
                    @error="
                        e =>
                            (e.target.src =
                                '/storage/assets/images/default.png')
                    "
                    class="remove_bg_color w-full h-full"
                    :alt="
                        'Image accessoire ' +
                        accessory.catalog.brand +
                        ' ' +
                        accessory.catalog.model
                    "
                />
            </div>
            <strong>{{ accessory.catalog.brand }}</strong
            ><br />
            {{ accessory.catalog.model }}<br />
            <strong
                >Prix :
                {{ formatPrice(accessory.catalog.price_htva * 1.21) }}</strong
            ><br />
            <div>
                <label
                    :for="'accessorySize' + accessory.accessories_catalog_id"
                    >{{
                        $translate('public.shop.home.bikes.card.details.size')
                    }}</label
                >

                <AppSelect
                    class="form-select"
                    v-model="accessory.size"
                    :options="
                        accessory.catalog.sizes.map(size => ({
                            label:
                                size +
                                (!accessory.catalog.stock[size]
                                    ? ' - ' +
                                      $translate(
                                          'public.shop.home.bikes.card.stock.not-in-stock',
                                      )
                                    : ''),
                            value: size,
                            disabled: !accessory.catalog.stock[size],
                        }))
                    "
                    optionLabel="label"
                    optionValue="value"
                    :disabled="accessory.disabled"
                    :id="'accessorySize' + accessory.accessories_catalog_id"
                />
            </div>
            <primary-button
                :disabled="!accessory.size"
                color="red"
                @click="
                    addToCart('accessory', accessory.catalog, accessory.size)
                "
                class="bottom-0"
            >
                <i class="fas fa-shopping-cart"></i>
                <p class="text-xs">
                    {{
                        $translate('public.shop.home.bikes.card.details.order')
                    }}
                </p>
            </primary-button>
        </div>
        <CartModal ref="childRef" />
    </div>
</template>

<script setup>
import { defineProps, ref } from 'vue';
import formatPrice from '@/js/functions/formatPrice.js';
import { usePopupStore } from '@/js/stores/popupStore.js';
import CartModal from '@/js/views/public/shop/cart/partials/Modal.vue';

const popupStore = usePopupStore();
const childRef = ref(null);

const addToCart = async (type, item, size) => {
    if (!size) {
        popupStore.show('warning', 'Veuillez selectionner une taille.');
    } else {
        childRef.value.addToCart(type, item, size);
    }
};

defineProps({
    chosenAccessories: Object,
});
</script>
